import $http from '../../shared/http';

export const notifications = {
  namespaced: true,
  state: () => {
    return {
      notifications: [],
      notificationsCount: { unread: null, saved: null, not_done: null },
    };
  },
  getters: {
    getNotificationsCount: (state) => state?.notificationsCount,
    getNotifications: (state) => state.notifications,
    getCompiledNotifications: (state) => {
      return state.notifications?.map((notification) => {
        const actor = notification?.activity?.actor;
        const description = notification?.activity?.description ?? notification?.description ?? '';
        const entityName = notification?.activity?.entity_name ?? '';
        const extras = notification?.activity?.extras ?? {};
        const entityId = notification?.activity?.entity_id ?? '';
        const time = notification.created_at;
        const actionType = notification?.activity?.action_type ?? '';
        const entityType = notification?.activity?.entity_type ?? '';
        const id = notification.id;
        const read = notification.read_status;
        const saved = notification.saved;
        const done = notification.done;

        return {
          description,
          entityName,
          entityId,
          time,
          actionType,
          entityType,
          id,
          read,
          saved,
          done,
          actor,
          extras,
        };
      });
    },
  },
  mutations: {
    setNotificationsCount: (state, data) => {
      state.notificationsCount.unread = data.unread[0].count;
      state.notificationsCount.saved = data.saved[0].count;
      state.notificationsCount.not_done = data.not_done[0].count;
    },

    setCurrentPage: (state, page) => (state.currentPage = page),

    setPaginatedNotifications: (state, data) => {
      if (!data || !data.length) {
        state.notifications = [];
        return;
      }

      state.notifications.splice(0, state.notifications.length, ...data);
    },
    incrementNotificationsCount: (state) => state.notificationsCount.unread++,

    setMarkAsRead: (state, payload) => {
      const { id, readStatus } = payload;
      const notification = state.notifications.find((n) => Number(n.id) === Number(id));
      notification.read_status = readStatus;
      readStatus ? state.notificationsCount.unread-- : state.notificationsCount.unread++;
    },

    setMarkAsSaved: (state, payload) => {
      const { id, saved } = payload;
      const notification = state.notifications.find((n) => Number(n.id) === Number(id));
      notification.saved = saved;
      saved ? state.notificationsCount.saved++ : state.notificationsCount.saved--;
    },

    setMarkAsDone: (state, payload) => {
      const { id, done } = payload;
      const notification = state.notifications.find((n) => Number(n.id) === Number(id));
      notification.done = done;
      done ? state.notificationsCount.not_done-- : state.notificationsCount.not_done++;
    },

    setMarkAllAs: (state, payload) => {
      /** @type {{selected: number[], action: 'done' | 'not_done' | 'read' | 'unread' | 'saved'}} */
      const { selected, action } = payload;

      selected.forEach((id) => {
        const notification = state.notifications.find((n) => Number(n.id) === Number(id));

        switch (action) {
          case 'done':
            notification.done = true;
            break;
          case 'not_done':
            notification.done = false;
            break;
          case 'read':
            notification.read_status = true;
            break;
          case 'unread':
            notification.read_status = false;
            break;
          case 'saved':
            notification.saved = true;
            break;

          default:
            break;
        }
      });
    },
  },
  actions: {
    async loadPaginatedNotificationsAction({ commit, dispatch }, { query, churchId }) {
      return new Promise(async (resolve, reject) => {
        await $http('v2')
          .get(`${churchId ? `organisations/${churchId}` : ''}/notifications`, { params: query })
          .then((response) => {
            commit('setPaginatedNotifications', response.data.data);
            dispatch('loadNotificationCountAction', {
              churchId,
            });
            return resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    async updateNotificationAction({ commit }, { id, read, done, saved, churchId }) {
      return new Promise(async (resolve, reject) => {
        await $http('v2')
          .patch(`${churchId ? `organisations/${churchId}` : ''}/notifications/${id}`, {
            read,
            done,
            saved,
          })
          .then((response) => {
            if (read !== undefined) {
              commit('setMarkAsRead', { id, readStatus: read });
            }
            if (saved !== undefined) {
              commit('setMarkAsSaved', { id, saved });
            }
            if (done !== undefined) {
              commit('setMarkAsDone', { id, done });
            }
            return resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    async massUpdateNotificationsAction(
      { commit, dispatch },
      { selected, selectAllUnread, action, churchId }
    ) {
      return new Promise(async (resolve, reject) => {
        await $http('v2')
          .patch(
            `${churchId ? `organisations/${churchId}` : ''}/notifications`,
            { selected, selectAllUnread, action },
            { headers: { 'X-Is-Notifiable': 'On' } }
          )
          .then((response) => {
            commit('setMarkAllAs', { selected, action });
            dispatch('loadNotificationCountAction', {
              churchId,
            });
            return resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    async loadNotificationCountAction({ commit }, { churchId }) {
      return new Promise(async (resolve, reject) => {
        await $http('v2')
          .get(`${churchId ? `organisations/${churchId}` : ''}/notifications/stats`)
          .then((response) => {
            commit('setNotificationsCount', response.data.data);
            return resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};
